<script setup>

const props = defineProps({
	distributionCategory: {
    type: Object,
  },
	recordDealCategory: {
    type: Object,
  },
	exclusiveDealCategory: {
    type: Object,
  },
})

const activeCategory = ref(null)
const hoveredCategory = ref(null)

const { $event } = useNuxtApp()

const slideToCategory = (category, index) => {
  $event('slideToCategory', [category, index])
}

</script>

<template>
	<div class="hidden xl:block mb-28">
		<div class="flex gap-2 w-full mb-20">
			<div class="flex-1 cursor-pointer" @click="activeCategory = 'distribution'" @mouseenter="hoveredCategory = 'distribution'" @mouseleave="hoveredCategory = null">
				<h4 class="text-gold mb-8">{{ distributionCategory.title }}</h4>
				<div class="h-[360px]">
					<div class="flex items-end gap-2 h-full">
						<div class="bg-gold h-[15%] flex-1 relative">
							<p class="absolute top-[100%] mt-4 text-xl fullHD:text-2xl dark:text-light text-dark transition-all" :class="[hoveredCategory === 'distribution' || activeCategory === 'distribution' ? 'opacity-100' : 'opacity-40']">Starter</p>
						</div>
						<div class="bg-gold h-[35%] flex-1 relative">
							<p class="absolute top-[100%] mt-4 text-xl fullHD:text-2xl dark:text-light text-dark transition-all" :class="[hoveredCategory === 'distribution' || activeCategory === 'distribution' ? 'opacity-100' : 'opacity-40']">Pro</p>
						</div>
						<div class="bg-gold h-[55%] flex-1 relative">
							<p class="absolute top-[100%] mt-4 text-xl fullHD:text-2xl dark:text-light text-dark transition-all" :class="[hoveredCategory === 'distribution' || activeCategory === 'distribution' ? 'opacity-100' : 'opacity-40']">Premium</p>
						</div>
					</div>
				</div>
			</div>
			<div class="flex-1 cursor-pointer" @click="activeCategory = 'record'" @mouseenter="hoveredCategory = 'record'" @mouseleave="hoveredCategory = null">
				<h4 class="text-cyan mb-8">{{ recordDealCategory.title }}</h4>
				<div class="h-[360px] mb-4 relative">
					<div class="bg-cyan absolute bottom-0 h-[70%] left-0 w-full"></div>
				</div>
				<p class="text-xl fullHD:text-2xl dark:text-light text-dark transition-all" :class="[hoveredCategory === 'record' || activeCategory === 'record' ? 'opacity-100' : 'opacity-40']">Label</p>
			</div>
			<div class="flex-1 cursor-pointer" @click="activeCategory = 'exclusive'" @mouseenter="hoveredCategory = 'exclusive'" @mouseleave="hoveredCategory = null">
				<h4 class="text-magenta mb-8">{{ exclusiveDealCategory.title }}</h4>
				<div class="h-[360px] mb-4 relative">
					<div class="bg-magenta h-full"></div>
				</div>
				<p class="text-xl fullHD:text-2xl dark:text-light text-dark transition-all" :class="[hoveredCategory === 'exclusive' || activeCategory === 'exclusive' ? 'opacity-100' : 'opacity-40']">Exclusive</p>
			</div>
		</div>
		<div class="flex flex-wrap justify-center gap-8 max-w-[1024px] mx-auto">
			<a v-for="(item, index) in distributionCategory.items" :key="index" href="#" @click.prevent="slideToCategory(distributionCategory.specific, index)" class="text-2xl fvs600 transition-all hover:opacity-100" :class="[hoveredCategory === 'distribution' || activeCategory === 'distribution' || hoveredCategory === 'record' || activeCategory === 'record' || hoveredCategory === 'exclusive' || activeCategory === 'exclusive' ? 'opacity-100 text-gold' : 'opacity-35 dark:text-light text-dark']">{{ item.title }}</a>
		
			<a v-for="(item, index) in recordDealCategory.items" :key="index" href="#" @click.prevent="slideToCategory(recordDealCategory.specific, index)" class="text-2xl fvs600 transition-all hover:opacity-100" :class="[hoveredCategory === 'record' || activeCategory === 'record' || hoveredCategory === 'exclusive' || activeCategory === 'exclusive' ? 'opacity-100 text-cyan' : 'opacity-35 dark:text-light text-dark']">{{ item.title }}</a>
		
			<a v-for="(item, index) in exclusiveDealCategory.items" :key="index" href="#" @click.prevent="slideToCategory(exclusiveDealCategory.specific, index)" class="text-2xl fvs600 transition-all hover:opacity-100" :class="[hoveredCategory === 'exclusive' || activeCategory === 'exclusive' ? 'opacity-100 text-magenta' : 'opacity-35 dark:text-light text-dark']">{{ item.title }}</a>
		</div>
	</div>
</template>